/**
 * Created by mathieudeumie on 30/04/2014.
 */

angular.module('FlexyBeautyApp.services').
    factory('StoreApp_Resource',["$resource","$location",
        function ($resource,$location)
        {
            var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
            return $resource(baseUrl+'rest/storeApps/:id',{}, {
                query: { method: 'GET', isArray: true },
                get: { method: 'GET' }
            });
        }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('StoreApp',["StoreApp_Resource","StoreAppData",
        function (StoreApp_Resource,StoreAppData)
        {
            var StoreApp = function (resource)
            {
                this.id = null;
                this.isDeleted = false;
                this.code = null;
                this.order = null;
                this.label = null;
                this.isActiveByDefault = true;
                this.isChangeable = true;
                this.type = null;  //subscription,usageBased,discount
                this.status = null;//released / beta / future
                this.usageLabel = null;
                this.isVisibleForCustomers = true;
                this.mandatoryBases = "";
                this.description = null;
                this.videoUrl = null;
                this.price = null;
                this.percentDiscount = null;
                this.trialTime = null;
                this.propagateStoreAppSettings = false;
                this.isMain = false;

                if(resource !== undefined && resource !== null)
                    this.loadObject(resource);

                StoreAppData.add(this);
            };

            StoreApp.prototype.setId = function(id)
            {
                this.id = id;
            };
            StoreApp.prototype.getId = function()
            {
                return this.id;
            };

            StoreApp.prototype.loadObject = function(object)
            {
                if (object)
                {
                    if (!this.id)
                        this.id = object.id;
                    if (object.timeCreated)
                        this.timeCreated = new Date(object.timeCreated);
                    this.isDeleted = object.isDeleted;
                    this.code = object.code;
                    this.label = object.label;
                    this.order = object.order;
                    this.isActiveByDefault = object.isActiveByDefault;
                    this.isChangeable = object.isChangeable;
                    this.type = object.type;
                    this.status = object.status;
                    this.usageLabel = object.usageLabel;
                    this.isVisibleForCustomers = object.isVisibleForCustomers;
                    this.mandatoryBases = object.mandatoryBases;
                    this.description = object.description;
                    this.videoUrl = object.videoUrl;
                    this.price = object.price;
                    this.percentDiscount = object.percentDiscount;
                    this.trialTime = object.trialTime;
                    this.isMain = object.isMain;
                }
            };


            StoreApp.prototype.getObjectResource = function(object)
            {
                var newApp = new StoreApp_Resource();

                newApp.id = this.id;
                newApp.isDeleted = this.isDeleted;
                newApp.code = this.code;
                newApp.label = this.label;
                newApp.order = this.order;
                newApp.isActiveByDefault = this.isActiveByDefault;
                newApp.isChangeable = this.isChangeable;
                newApp.type = this.type;
                newApp.status = this.status;
                newApp.usageLabel = this.usageLabel;
                newApp.isVisibleForCustomers = this.isVisibleForCustomers;
                newApp.mandatoryBases = this.mandatoryBases;
                newApp.description = this.description;
                newApp.videoUrl = this.videoUrl;
                newApp.price = this.price;
                newApp.percentDiscount = this.percentDiscount;
                newApp.trialTime = this.trialTime;
                newApp.propagateStoreAppSettings = this.propagateStoreAppSettings;//one time only
                this.propagateStoreAppSettings = false;
                newApp.isMain = this.isMain;
                return newApp;
            }

            return StoreApp;
        }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('StoreAppSrv',["$log","ServerSrv","StoreApp_Resource","StoreAppData","StoreApp",
        function ($log,ServerSrv,StoreApp_Resource,StoreAppData,StoreApp)
        {
            var storeAppSrv = {};

            storeAppSrv.query = function(successFunction,errorFunction)
            {
                StoreApp_Resource.query(
                    {}, //params
                    function (data) {
                        StoreAppData.clear();
                        for(var i=0;i<data.length;i++)
                        {
                            new StoreApp(data[i]);
                        }

                        if (successFunction!== undefined)
                            successFunction();
                    },
                    function (data) {
                        if (errorFunction !== undefined)
                            errorFunction(data);
                    }
                );
            };
            storeAppSrv.save = function(storeApp,successFunction,errorFunction)
            {
                ServerSrv.startSavingProcess(storeAppSrv.saveSync, storeApp, successFunction, errorFunction);
            };
            storeAppSrv.saveSync = function(storeApp,successFunction,errorFunction)
            {
                var storeAppRes = storeApp.getObjectResource();
                storeAppRes.$save({}, //no params
                    function (data) {
                        try{
                            storeApp.setId(data.id);
                            if (successFunction !== undefined)
                                successFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(true);
                        }
                    },
                    function (data) {   //failure
                        //error handling goes here
                        try{
                            if (errorFunction !== undefined)
                                errorFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                        }
                    }
                );
            };
            storeAppSrv.remove = function(storeApp,successFunction,errorFunction)
            {
                StoreAppData.remove(storeApp);
                ServerSrv.startSavingProcess(storeAppSrv.removeSync, storeApp, successFunction, errorFunction);
            };
            storeAppSrv.removeSync = function(storeApp,successFunction,errorFunction)
            {
                //$timeout (function () {

                var storeAppRes = storeApp.getObjectResource();
                storeAppRes.$remove({id:storeApp.getId()}, //no params
                    function (data) {
                        try{
                            if (successFunction !== undefined)
                                successFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(true);
                        }
                    },
                    function (data) {
                        //error handling goes here
                        try{
                            if (errorFunction !== undefined)
                                errorFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                        }
                    }
                );

                //},2000)
            };

            return storeAppSrv;
        }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('StoreAppData',["$filter",
        function ($filter)
        {
            var  storeAppDataSrv =
            {
                indexStoreApps : [],
                activeStoreApps : [],
                deletedStoreApps : []//deleted items
            };
            storeAppDataSrv.getById =  function(storeAppId)
            {
                for (var i=0;i<this.indexStoreApps.length;i++)
                    if (this.indexStoreApps[i].id==storeAppId)
                        return this.indexStoreApps[i];
                return null;
            }
            storeAppDataSrv.getByCode =  function(storeAppCode)
            {
                for (var i=0;i<this.indexStoreApps.length;i++)
                    if (this.indexStoreApps[i].code==storeAppCode)
                        return this.indexStoreApps[i];
                return null;
            }
            storeAppDataSrv.getByIndex =  function(index)
            {
                if (index>=0 && index <this.indexStoreApps.length)
                    return this.indexStoreApps[index];
                return null;
            }
            storeAppDataSrv.getIndexOf =  function(storeApp)
            {
                if (storeApp)
                    return this.indexStoreApps.indexOf(storeApp);
                return -1;
            }

            storeAppDataSrv.add =  function(storeApp)
            {
                var storeAppArray = this.activeStoreApps;
                if (storeApp.isDeleted)
                    storeAppArray =  this.deletedStoreApps;
                var index =  this.indexStoreApps.indexOf(storeApp);
                if (index!=-1)
                {
                    var realIndex = storeAppArray.indexOf(storeApp);
                    if (realIndex==-1)
                        storeAppArray.push(storeApp);
                }
                else
                {
                    index = this.indexStoreApps.length
                    this.indexStoreApps.push(storeApp);
                    storeAppArray.push(storeApp);
                }
                return index;
            }
            storeAppDataSrv.remove =  function(storeApp)
            {
                var index =  this.activeStoreApps.indexOf(storeApp);
                if (index!=-1)
                {
                    this.activeStoreApps.splice(index, 1);
                    this.deletedStoreApps.push(storeApp)
                    storeApp.isDeleted=true;
                }
            }
            storeAppDataSrv.restore =  function(storeApp)
            {
                var index =  this.deletedStoreApps.indexOf(storeApp);
                if (index!=-1)
                {
                    this.deletedStoreApps.splice(index, 1);
                    this.activeStoreApps.push(storeApp);
                    storeApp.isDeleted=false;
                }
            }
            storeAppDataSrv.clear =  function()
            {
                this.indexStoreApps = [];
                this.activeStoreApps = [];
                this.deletedStoreApps = [];
            }
            storeAppDataSrv.sort =  function()
            {
                this.activeStoreApps = $filter('orderBy')(this.activeStoreApps,'label', false);
                this.deletedStoreApps = $filter('orderBy')(this.deletedStoreApps,'label', false);
            }

            storeAppDataSrv.getActiveList =  function()
            {
                return this.activeStoreApps;
            }
            storeAppDataSrv.getDeletedList =  function()
            {
                return this.deletedStoreApps;
            }
            return   storeAppDataSrv;
        }
    ]);



// WEBPACK FOOTER //
// ./js/services/models/StoreApp.js